import React, { useState } from 'react';
import NavigationHeder from '../../../components/Navigations/NavigationHeder';
import Settings from '../../../inc/Settings';
import axios from 'axios';
import Helper from '../../../inc/Helper';
import $ from 'jquery';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import AgGridNew from '../../../components/grid/ag/ag-grid-new';
import MasterComponentWraper from '../../../components/Backend/MasterComponentWraper';
import { connect } from 'react-redux';
import { exportToXlsx, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import NewOverlayLoader from '../../../components/PurchaseRequisition/common/NewOverlayLoader';
import { generateBaseUrl } from '../../../components/grid/ag/commonFunctions/GridCommonFunctions';
import RefreshGridBtn from '../../../components/inc/RefreshGridBtn';
import Api from '../../../inc/Api';

let gridApi = null;

const Instances = (props) => {
  const [selectedRowInstance, setSelectedRowInstance] = useState(null);
  const [restartingWorkflow, setRestartingWorkflow] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const restartWorkflow = () => {
    if (!selectedRowInstance) {
      Helper.alert("Please select a workflow for restart", 'error');
      return;
    };

    setRestartingWorkflow(true);
    let api = Api;
    api.setUserToken()
    api.axios().post(Settings.baseUrl + `instance/restart`, { 'instance_id': selectedRowInstance }).then((res) => {
      if (res?.data?.status === 200) {
        Helper.alert(res?.data?.message);
        setRestartingWorkflow(false);
        gridApi?.api?.refreshServerSide({ purge: true });
        gridApi?.api?.deselectAll();
      };
    }).catch((error) => {
      setRestartingWorkflow(false);
      getPopupMessageBasedOnStatus(error);
    })
  };
 
  const RefreshFailedScenariosBtn = () => {
    return (
      <div className='import_sample_template'> 
        <button disabled={!selectedRowInstance} className={`rs_h_controller rs_setvalue_btn visible_on_select_item ${!selectedRowInstance ? 'ctl-dissable' : ''}`} onClick={restartWorkflow}>
          <FontAwesomeIcon icon={faPowerOff} />
          <span>Restart</span>
        </button>
      </div>
    )
  };

  const ExportExcelBtn = () => {
    return (
      <div className="import_sample_template">
        <button onClick={exportData}>
          <img className="img-fluid" src="/images/icons/excel-logo.svg" alt="excel-logo" /> Export
        </button>
      </div>
    )
  };

  const onSelectionChangedInstances = (event) => {
    let currentNode = event.api.getSelectedRows();

    if (currentNode?.length <= 0 || !currentNode[0]?.instance_id){
      setSelectedRowInstance(null);
      $('.rs_setvalue_btn').addClass('ctl-dissable');
      $('.visible_on_select_item').addClass('ctl-dissable'); 
    } else {
      setSelectedRowInstance(currentNode[0]?.instance_id);
      $('.rs_setvalue_btn').removeClass('ctl-dissable');
      $('.visible_on_select_item').removeClass('ctl-dissable'); 
    }
  };

  const gridColumnsFailedInstances = [
    { field: 'workflow_name', headerName: 'Workflow name', minWidth: 350 },
    { field: 'template_name', headerName: 'Template name', minWidth: 250 },
    { field: 'document_number', headerName: 'Document number', minWidth: 250 },
    { field: 'workflow_version', headerName: 'Versions' },
    { field: 'trigger', headerName: 'Trigger option' },
    { field: 'reason', headerName: 'Reason for failed', minWidth: 850 },
    { field: 'module_item_id', headerName: 'Integrator' },
    { field: 'status', headerName: 'Status' }
  ];

  const reloadGrid = () => {
    gridApi?.api?.refreshServerSide({ purge: true });
    gridApi?.api?.deselectAll();
  };

  const exportData = async () => {
    setExportLoading(true);

    const apiUrl = Settings.baseUrl + `instance/failed`;
    const params = `?tenant_id=${props?.user?.tenant_id}`;

    let pagination = false;
    let defaultAdvanceFilterObj = false; 

    const baseUrl = generateBaseUrl({ gridObj: gridApi, apiUrl, params, pagination, defaultAdvanceFilterObj });
    await exportToXlsx({ url: baseUrl, columns: (gridColumnsFailedInstances), fileName: "failed_instances_details", apiTokenRequired: false });
    
    setExportLoading(false);
  };

  return (
    <> 
      <NavigationHeder hideBackButton={true} title={`<span style="color:#000;"> Home > </span>  ${'Failed Instances'}`} />
      
      { restartingWorkflow || exportLoading ? <NewOverlayLoader /> : null }
      
      <AgGridNew
        apiUrl={Settings.baseUrl + `instance/failed`} 
        hideAddBtn={true}
        hideDeleteBtn={true}
        onSelectionChanged={onSelectionChangedInstances} 
        rowType={'single'}  
        gridId={'workflow_failed_instances_grid'}
        columnDefs={gridColumnsFailedInstances} 
        apiTokenRequired={false}
        onGridReady={ event => gridApi = event }
        height={500}
        btnsWrapperStyle="w-100"
        additionalParams={`?tenant_id=${props?.user?.tenant_id}`} // change this ? to & once pagination is true
        filterAdditionalParams={`?tenant_id=${props?.user?.tenant_id}`} // change this ? to & once pagination is true
        afterDeleteBtns={
          <div className="d-flex align-items-center w-100">
            <RefreshFailedScenariosBtn />

            <div className="d-flex align-items-center ms-auto"> 
              <ExportExcelBtn />
              <div className='me-3'>
                <RefreshGridBtn onClickRefreshBtn={reloadGrid} />
              </div> 
            </div>
          </div>
        }
        pagination={false}  
      /> 
    </>
  )
};

const mapStateToProps = (state) => {
  return { 
    user: state.auth.user
  }
};

export default connect(mapStateToProps) (MasterComponentWraper(Instances));